import React from 'react';
import useSetTitle from '../../../../hooks/useSetTitle';
import Root from '../Root';
import AccountHeadline from './components/AccountHeadline';
import NavTiles from './components/NavTiles';

type Props = {
  params: any;
};

const GetCare = (props: Props) => {
  const {
    params: { userProfileId },
  } = props;

  useSetTitle('Get Care');

  return (
    <Root>
      <AccountHeadline userProfileId={userProfileId} />
      <NavTiles userProfileId={userProfileId} />
    </Root>
  );
};

export default GetCare;
